import {staticMapKey} from '../../../config'
import {storage} from '../../../utilities'
import { ref, uploadBytes } from 'firebase/storage'

export default async function getStaticMapThumbnail(site) {
  const {lat, lng} = site.geocode_results.geometry.location

  const mapUrl =
    `https://maps.googleapis.com/maps/api/staticmap` +
    `?center=${lat},${lng}` +
    `&zoom=13&size=500x200` +
    `&maptype=roadmap` +
    `&markers=color:green%7C${lat},${lng}` +
    `&key=${staticMapKey}`

  const res = await fetch(mapUrl)
  const b = await res.blob()

  const imageRef = ref(storage, `siteThumbnails/${site.id}`)
  await uploadBytes(imageRef, b)

  const {bucket, fullPath, name} = imageRef
  site.thumbnail = {bucket, fullPath, name}
  return site
}
